exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".newResponsePage .printOp{margin-left:15px}.newResponsePage .textTitle{font-size:2.1em;font-style:italic;text-align:center;max-width:80%;margin-left:10%;margin-top:10px;margin-bottom:20px}.newResponsePage .smallerHeader{font-size:1em}.newResponsePage .largerHeader{font-size:1.4em}.newResponsePage .studentCurrentAssignment .pageHeader h1{font-size:1.4em!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/writing/responses/new_response_page.scss
// module id = 1536
// module chunks = 0